module.exports = __webpack_public_path__ + "static/media/illo_smile.83ae05f6.png";